import { render, staticRenderFns } from "./YuanGongRecord.vue?vue&type=template&id=38844a41"
import script from "./YuanGongRecord.vue?vue&type=script&lang=js"
export * from "./YuanGongRecord.vue?vue&type=script&lang=js"
import style0 from "./YuanGongRecord.vue?vue&type=style&index=0&id=38844a41&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports